<template>
    <div class="minisite-tag-list tag-list-00" v-if="showedData" :style="getToggleListStyle">
        <div class="list-search"
             v-show="getShowedComponent.search">
            <search-component @search="search" :settings="data.search"
                              v-model="searchWord"
                              :search-style="showedData.style.searchStyle"
            ></search-component>
        </div>
        <template
            v-if="showedData && showedData.contents&& showedData.contents.length>0">
            <van-tabs :color="showedData.style.listStyle.active.color||`var(--c-site-primary-color-)`"
                      :title-active-color="showedData.style.listStyle.active.color||`var(--c-site-primary-color-)`"
                      :title-inactive-color="showedData.style.listStyle.normal.color"
                      background="none"
                      @change="tabChange"
                      v-model="activeKey"
                      animated
                      swipeable
                      :ellipsis="false"
                      class="custom-tab"
                      :lazy-render="false"
                      :class="{'wrap': showedData.style.listStyle.tabs?showedData.style.listStyle.tabs.wrap.enable:false,
                      'grow':showedData.style.listStyle.tabs?showedData.style.listStyle.tabs.wrap.col:false}"
                      :style="{'--active-color':showedData.style.listStyle.active.color||`var(--c-site-primary-color-)`}"
            >
                <template
                    v-for="item in showedData.contents">
                    <van-tab v-if="item.matched"
                             class="item"
                             :key="item.id"
                             :title-style="{
                    fontSize:data.style.listStyle.normal.fontSize + 'px',
                    fontWeight:data.style.listStyle.normal.fontWeight?'bold':'normal',
                    width:getTitleWidth
                }" :title="item.title.content">
                        <inner-list :data="item" :data-source="data.dataSource"
                                    :search-word="searchWord"></inner-list>
                    </van-tab>
                </template>
            </van-tabs>
        </template>
    </div>
</template>

<script>
    import tagList from "./tagList.mixin"
    import Vue from "vue"
    import Tabs from "vant/lib/tabs"
    import Tab from "vant/lib/tab"
    import "vant/lib/tabs/style"
    import "vant/lib/tab/style"

    Vue.use(Tab)
    Vue.use(Tabs)

    export default {
        name: "Template-00",
        mixins: [tagList],
        props: {
            data: {}
        },
        computed: {
            getToggleListStyle() {
                return {}
            }
        },
        mounted() {

        }
    }
</script>

<style lang="less">
    .minisite-tag-list {
        .search-container {
            position: relative;

            .search-input {
                width: 100%;
                border-style: solid;
                border-width: 1px;
                outline: none;
                height: 28px;
                line-height: 28px;
                padding: 0 30px 0 12px;
                pointer-events: none;
            }

            .search-icon {
                position: absolute;
                top: 4px;
                right: 10px;
                width: 20px;
                height: 20px;
            }
        }

        .image_resized {
            width: initial;
            display: flex;
            margin: 0;

            img {
                width: 100%;
                height: initial;
            }
        }

        figure {

            &.image {
                margin: 0;
                height: fit-content;
                display: flex;
                align-items: center;

                img {
                    margin: 0 auto;
                }
            }
        }

        .minisite-tag-list-item {
            /*display: flex;*/
            /*flex-direction: column;*/

            .editor-item-content {
                line-height: 2;
            }

            .list-header {
                /*width: 100%;*/
                display: flex;
                align-items: center;
                /*flex-grow: 1;*/

                .list-header-title {
                    flex-grow: 1;
                    vertical-align: middle;
                    line-height: 1.5;
                }

                .list-header-icon {
                    transition: all .3s ease;
                    flex-shrink: 0;
                    max-width: 30px;
                }
            }

            .list-body {
                max-height: 0;
                overflow: hidden;
                transition: height .3s ease;
                padding: 0;
                margin: 0;
            }

            &.closed {
                .list-body {
                    margin: 0 !important;
                    padding: 0 !important;
                    border: none !important;
                }
            }

            &.open {
                .list-body {
                    max-height: inherit;
                }

                .list-header-icon {
                    transform: rotate(90deg);
                }
            }
        }

    }


</style>
